/* Fuego & Fragancia — product page: gallery, quantity, ritual add-ons, add-to-cart */

if (!customElements.get('ff-product-gallery')) {
  customElements.define(
    'ff-product-gallery',
    class FfProductGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = this.querySelectorAll('.ff-product__thumb[data-media-index]');
        this.slides = Array.from(this.querySelectorAll('.ff-product__main-slide'));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.select(thumb.dataset.mediaIndex));
        });

        this.prev = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');

        // Con una sola foto las flechas no llevan a ningun sitio.
        if (this.slides.length > 1) {
          if (this.prev) { this.prev.hidden = false; this.prev.addEventListener('click', () => this.step(-1)); }
          if (this.next) { this.next.hidden = false; this.next.addEventListener('click', () => this.step(1)); }
        }
      }

      // Se avanza por la POSICION en el DOM, no por el numero del atributo: los
      // indices tienen huecos a proposito (la segunda foto se reserva para la
      // seccion de fragancia), asi que sumar uno al indice caeria en el vacio.
      step(direccion) {
        const actual = this.slides.findIndex((s) => s.classList.contains('is-active'));
        const desde = actual < 0 ? 0 : actual;
        const total = this.slides.length;
        const destino = (desde + direccion + total) % total;
        this.select(this.slides[destino].dataset.mediaIndex);
      }

      select(index) {
        this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaIndex === index));
        this.slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaIndex === index));
      }
    }
  );
}

if (!customElements.get('ff-product-form')) {
  customElements.define(
    'ff-product-form',
    class FfProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-ff-variant-input]');
        this.qtyInput = this.querySelector('.ff-product__qty-input');
        this.addonInputs = this.querySelectorAll('.ff-addons__checkbox');
        this.totalEl = this.querySelector('[data-ff-add-total]');
        this.priceEl = this.querySelector('[data-ff-price]');
        this.submitButton = this.querySelector('.ff-product__add');

        this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
        this.currency = this.dataset.currency || 'USD';

        this.querySelectorAll('[data-qty-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const delta = parseInt(btn.dataset.qtyChange, 10);
            const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
            this.qtyInput.value = next;
            this.updateTotal();
          });
        });

        if (this.qtyInput) this.qtyInput.addEventListener('change', () => this.updateTotal());

        this.addonInputs.forEach((cb) => {
          cb.addEventListener('change', () => {
            cb.closest('.ff-addons__row').classList.toggle('is-checked', cb.checked);
            this.updateTotal();
          });
        });

        /* El carrusel es un elemento hermano, no un hijo: se busca dentro de
           la misma sección y solo se cae al documento como último recurso. */
        const raiz = this.closest('.ff-product');
        this.galeria = (raiz || document).querySelector('ff-product-gallery');

        this.querySelectorAll('.ff-product__pill[data-variant-id]').forEach((pill) => {
          pill.addEventListener('click', () => this.selectVariant(pill));
        });

        /* Selector de DOS O MÁS opciones (tamaño + color). Cada fila elige un
           valor; la combinación de todas resuelve la variante. */
        this.opts = this.querySelector('[data-ff-opts]');
        if (this.opts) {
          try {
            this.variantesOpts = JSON.parse(this.opts.dataset.variants || '[]');
          } catch (e) {
            this.variantesOpts = [];
          }
          this.opts.querySelectorAll('.ff-product__pill[data-opt-value]').forEach((pill) => {
            pill.addEventListener('click', () => this.elegirOpcion(pill));
          });
        }

        /* Desplegable de formatos (Sales de Baño): un panel propio, no un
           <select> nativo — así se puede pintar oscuro y con divisiones
           entre opciones, cosa que la lista de un <select> no admite de
           forma fiable entre navegadores. Cada opción sigue siendo un
           <a href> normal: NAVEGA, igual que las píldoras de hermanos, no
           cambia ninguna variante. Este bloque solo abre y cierra el panel. */
        this.querySelectorAll('[data-ff-format-dropdown]').forEach((dropdown) => {
          const trigger = dropdown.querySelector('[data-ff-format-trigger]');
          const list = dropdown.querySelector('[data-ff-format-list]');
          if (!trigger || !list) return;

          const cerrar = () => {
            list.hidden = true;
            dropdown.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          };
          const abrir = () => {
            list.hidden = false;
            dropdown.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          };

          trigger.addEventListener('click', () => {
            if (list.hidden) abrir();
            else cerrar();
          });

          // Fuera del panel, o Escape: se cierra. `composedPath` no hace
          // falta aquí porque no hay Shadow DOM de por medio.
          document.addEventListener('click', (event) => {
            if (!dropdown.contains(event.target)) cerrar();
          });
          document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') cerrar();
          });
        });

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));

          /* COMPRAR AHORA en un producto personalizable es un submit mas, no
             un enlace: tiene que pasar por aqui para que los nombres viajen.
             Se apunta a donde hay que ir DESPUES de agregar; los otros
             botones lo borran, para que un clic anterior no arrastre a nadie
             al pago sin querer. */
          this.destinoTrasAgregar = null;
          document.querySelectorAll('[data-ff-checkout]').forEach((b) => {
            b.addEventListener('click', () => {
              this.destinoTrasAgregar = b.dataset.checkoutUrl || '/checkout';
            });
          });
          const alCarrito = [this.submitButton].concat(
            Array.from(document.querySelectorAll('[data-ff-sticky-add]'))
          );
          alCarrito.forEach((b) => {
            if (b) b.addEventListener('click', () => { this.destinoTrasAgregar = null; });
          });
        }

        this.updateTotal();
      }

      selectVariant(pill) {
        this.querySelectorAll('.ff-product__pill[data-variant-id]').forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        this.variantInput.value = pill.dataset.variantId;
        this.basePrice = parseInt(pill.dataset.variantPrice, 10) || 0;
        this.mostrarFotoDeVariante(pill);
        this.actualizarStock(pill.dataset.variantId);
        // El precio en pantalla lo escribe updateTotal, que es quien conoce la
        // cantidad y los add-ons. Escribirlo aquí también lo dejaba un instante
        // con el precio unitario antes de corregirse.
        this.updateTotal();
      }

      /*
        Un clic en una fila de opciones. Marca el valor dentro de SU fila,
        junta lo elegido en todas las filas y busca la variante que coincida.

        Si esa combinación no existe (matriz incompleta) no se hace nada: es
        mejor dejar la selección anterior que dejar el formulario apuntando a
        una variante que no existe.
      */
      elegirOpcion(pill) {
        const fila = pill.closest('.ff-product__opt');
        if (!fila) return;
        fila
          .querySelectorAll('.ff-product__pill')
          .forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        const elegidas = Array.from(
          this.opts.querySelectorAll('.ff-product__opt')
        ).map((f) => {
          const activa = f.querySelector('.ff-product__pill.is-active');
          return activa ? activa.dataset.optValue : null;
        });

        const v = this.variantesOpts.find(
          (x) =>
            x.opts.length === elegidas.length &&
            x.opts.every((valor, i) => valor === elegidas[i])
        );
        if (!v) return;

        if (this.variantInput) this.variantInput.value = v.id;
        this.basePrice = v.price;

        if (v.media >= 0) {
          const g = this.galeria;
          if (g && typeof g.select === 'function') {
            const existe = g.querySelector(
              '.ff-product__main-slide[data-media-index="' + v.media + '"]'
            );
            if (existe) g.select(String(v.media));
          }
        }

        this.actualizarStock(String(v.id));
        this.updateTotal();
      }

      /*
        Contador de stock: al cambiar de variante, cambia el número y el color
        del punto. El mapa variante -> unidades viene en un data-attribute que
        pinta Liquid, así que no hay que pedirle nada al servidor.

        Si el producto no tiene el contador (apagado en el editor, o inventario
        sin seguimiento) simplemente no hay elemento y esto se sale.
      */
      actualizarStock(variantId) {
        const caja = this.querySelector('[data-ff-stock]');
        if (!caja || !variantId) return;

        let mapa;
        try {
          mapa = JSON.parse(caja.dataset.stockMap || '{}');
        } catch (e) {
          return;
        }

        // Cada variante trae [unidades, sigueVendiendoSinStock]
        const fila = mapa[variantId];
        if (!fila) return;

        const unidades = fila[0];
        const sigueVendiendo = fila[1] === 1;
        const hay = unidades > 0;

        // Agotado y se sigue vendiendo: el contador se va del todo, igual que
        // hace Liquid al cargar. Sin stock y sin venta: rojo.
        if (!hay && sigueVendiendo) {
          caja.hidden = true;
          return;
        }
        caja.hidden = false;

        const texto = caja.querySelector('[data-ff-stock-text]');
        caja.classList.toggle('is-out', !hay);
        if (texto) {
          texto.textContent = hay
            ? (caja.dataset.label || '').replace('[n]', unidades)
            : caja.dataset.labelOut || '';
        }
      }

      /*
        Lleva el carrusel a la foto de la variante elegida.

        Se sale sin hacer nada en tres casos, y los tres son normales:
        la píldora no trae foto (el ajuste está apagado, o esa variante no
        tiene imagen propia), no hay carrusel en la página, o la foto que
        pide es la segunda — que se reserva para la sección de fragancia y no
        existe como diapositiva. Sin esa última comprobación el carrusel se
        quedaría sin ninguna foto activa, en blanco.
      */
      mostrarFotoDeVariante(pill) {
        const idx = pill.dataset.variantMedia;
        if (idx === undefined || idx === '') return;
        const g = this.galeria;
        if (!g || typeof g.select !== 'function') return;
        const existe = g.querySelector(
          '.ff-product__main-slide[data-media-index="' + idx + '"]'
        );
        if (!existe) return;
        g.select(idx);
      }

      /*
        Cambio de variante pedido desde fuera (la barra fija). Si existe la
        pastilla equivalente se reutiliza selectVariant para que la ficha de
        arriba también quede marcada; si no la hay —porque este producto usa el
        selector de formatos y no el de variantes— se aplica a mano con el
        precio que trae la opción.
      */
      selectVariantById(id, price) {
        const pill = this.querySelector('.ff-product__pill[data-variant-id="' + id + '"]');
        if (pill) {
          this.selectVariant(pill);
          return;
        }
        if (!this.variantInput) return;
        this.variantInput.value = id;
        if (typeof price === 'number' && !isNaN(price)) this.basePrice = price;
        this.updateTotal();
      }

      setQuantity(next) {
        if (!this.qtyInput) return;
        this.qtyInput.value = Math.max(1, next);
        this.updateTotal();
      }

      get quantity() {
        return Math.max(1, parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1);
      }

      // La barra fija vive colgada del <body>, fuera de este elemento, así que
      // el aviso sale por `document` en vez de burbujear.
      // "Comprar ahora" es un permalink de carrito (/cart/VARIANTE:CANTIDAD),
      // asi que funciona sin JavaScript. Esto solo lo mantiene al dia cuando
      // se cambia de variante o de cantidad; si el boton no existe, no hace
      // nada.
      updateBuyNow() {
        const enlace = document.querySelector('[data-ff-buy-now]');
        if (!enlace) return;
        const base = enlace.dataset.cartBase || '/cart/';
        const variante = this.variantInput ? this.variantInput.value : null;
        if (!variante) return;
        enlace.href = base + variante + ':' + Math.max(1, this.quantity || 1);
      }

      emitChange() {
        this.updateBuyNow();
        document.dispatchEvent(
          new CustomEvent('ff:product-change', {
            detail: {
              variantId: this.variantInput ? this.variantInput.value : null,
              priceText: this.formatMoney(this.basePrice),
              totalText: this.lastTotalText || this.formatMoney(this.basePrice),
              quantity: this.quantity,
            },
          })
        );
      }

      // Delegado en el ayudante compartido (ff-money.js), que usa el formato
      // de la tienda. Antes esto era un Intl.NumberFormat con el idioma de la
      // página: en inglés daba "$31.31" y en español "31,31 US$", así que el
      // precio cambiaba de forma según el idioma y no coincidía con el que
      // pinta el servidor.
      formatMoney(cents) {
        if (window.ffMoney) return window.ffMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      selectedAddons() {
        return Array.from(this.addonInputs).filter((cb) => cb.checked);
      }

      updateTotal() {
        const qty = this.quantity;
        let total = this.basePrice * qty;
        this.selectedAddons().forEach((cb) => {
          total += parseInt(cb.dataset.addonPrice, 10) || 0;
        });
        /*
          El total manda en TODOS los sitios donde se ve un precio: el precio
          grande de la ficha, el del botón y el de la barra fija.

          Antes el precio grande solo cambiaba al cambiar de variante, así que
          subir la cantidad a tres o marcar un add-on no movía nada en pantalla
          y el selector parecía roto: el cliente elegía tres velas y seguía
          leyendo el precio de una.
        */
        this.lastTotalText = this.formatMoney(total);
        if (this.totalEl) this.totalEl.textContent = this.lastTotalText;
        if (this.priceEl) this.priceEl.textContent = this.lastTotalText;
        this.emitChange();
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
          // continue anyway; aria-disabled is only set while a request is in flight
        }

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        // El envío puede venir del botón de la barra fija: se marca también él
        // para que quien lo pulsó vea que algo está pasando.
        document.querySelectorAll('[data-ff-sticky-add]').forEach((b) => b.classList.add('loading'));

        /* PERSONALIZACION. Este onSubmit arma el JSON a mano en vez de usar
           FormData, asi que los <input name="properties[...]"> no viajan
           solos: hay que recogerlos. Se hace ANTES de marcar el boton como
           ocupado para poder abortar limpiamente si falta algo. */
        const personaliza = document.querySelector('ff-personalize');
        if (personaliza && typeof personaliza.valida === 'function' && !personaliza.valida()) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          document.querySelectorAll('[data-ff-sticky-add]').forEach((b) => b.classList.remove('loading'));
          return;
        }

        const qty = Math.max(1, parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1);
        const items = [{ id: Number(this.variantInput.value), quantity: qty }];

        if (personaliza && typeof personaliza.recoger === 'function') {
          const props = personaliza.recoger();
          if (Object.keys(props).length) items[0].properties = props;
        }

        this.selectedAddons().forEach((cb) => {
          items.push({ id: Number(cb.dataset.addonVariantId), quantity: 1 });
        });

        // Se lee y se limpia ANTES de la peticion: si algo falla, el
        // siguiente clic no hereda el destino de este.
        const destino = this.destinoTrasAgregar;
        this.destinoTrasAgregar = null;

        const cartDrawer = document.querySelector('cart-drawer');
        const body = { items: items };

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[ff-product-form]', response.description || response.message);
              return;
            }

            /* Comprar ahora: ya esta en el carrito CON los nombres, ahora
               si se puede ir al pago. No se abre el cajon antes: seria un
               parpadeo justo antes de cambiar de pagina. */
            if (destino) {
              window.location = destino;
              return;
            }

            if (cartDrawer) {
              // Igual que hace product-form.js de Dawn: sin esto la clase
              // is-empty se queda pegada y `cart-drawer.is-empty .drawer__inner`
              // convierte el panel en grid, rompiendo el carrito entero.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }

            this.addonInputs.forEach((cb) => {
              cb.checked = false;
              cb.closest('.ff-addons__row').classList.remove('is-checked');
            });
            this.updateTotal();
          })
          .catch((error) => console.error('[ff-product-form]', error))
          .finally(() => {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            document.querySelectorAll('[data-ff-sticky-add]').forEach((b) => b.classList.remove('loading'));
          });
      }
    }
  );
}

/*
  Barra fija de compra.

  No duplica el formulario: su botón usa el atributo `form` de HTML para enviar
  el formulario principal, así que el add-on, la cantidad y la variante que
  viajan al carrito son exactamente los de arriba. Este elemento solo se ocupa
  de aparecer en el momento justo y de mantener sincronizado lo que se ve.
*/
if (!customElements.get('ff-sticky-buy')) {
  customElements.define(
    'ff-sticky-buy',
    class FfStickyBuy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        /*
          Al <body>. Un `position: fixed` deja de serlo en cuanto un ancestro
          tiene `transform`, `filter` o `perspective`, y la ficha de producto
          está llena de animaciones de entrada: dentro de la sección la barra
          quedaría clavada a mitad de página en vez de al borde de la pantalla.
        */
        if (this.parentElement !== document.body) {
          // En el editor la sección se repinta y nacería una barra nueva cada
          // vez; las anteriores ya no cuelgan de la sección, así que se limpian.
          document.querySelectorAll('body > ff-sticky-buy').forEach((old) => old.remove());
          document.body.appendChild(this);
        }
        this.dataset.ready = 'true';

        this.form = document.getElementById(this.dataset.form);
        this.productForm = document.querySelector('ff-product-form');
        this.priceEl = this.querySelector('[data-ff-sticky-price]');
        this.totalEl = this.querySelector('[data-ff-sticky-total]');
        this.qtyValue = this.querySelector('[data-ff-sticky-qty-value]');
        this.variantSelect = this.querySelector('[data-ff-sticky-variant]');
        this.formatSelect = this.querySelector('[data-ff-sticky-format]');

        this.bindControls();
        this.watchTrigger();
        this.watchCartDrawer();

        document.addEventListener('ff:product-change', (event) => this.sync(event.detail));
      }

      bindControls() {
        if (this.variantSelect) {
          this.variantSelect.addEventListener('change', () => {
            const opcion = this.variantSelect.selectedOptions[0];
            if (!opcion || !this.productForm) return;
            this.productForm.selectVariantById(opcion.value, parseInt(opcion.dataset.price, 10));
          });
        }

        // El de formatos navega: son productos distintos, no variantes.
        if (this.formatSelect) {
          this.formatSelect.addEventListener('change', () => {
            const destino = this.formatSelect.value;
            if (destino) window.location.href = destino;
          });
        }

        this.querySelectorAll('[data-ff-sticky-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!this.productForm) return;
            const delta = parseInt(btn.dataset.ffStickyQty, 10) || 0;
            this.productForm.setQuantity(this.productForm.quantity + delta);
          });
        });
      }

      sync(detail) {
        if (!detail) return;
        // El total, no el precio unitario: la barra tiene que decir lo mismo
        // que la ficha de arriba y lo mismo que se va a cobrar.
        if (this.priceEl && detail.totalText) this.priceEl.textContent = detail.totalText;
        if (this.totalEl && detail.totalText) this.totalEl.textContent = detail.totalText;
        if (this.qtyValue && detail.quantity) this.qtyValue.textContent = detail.quantity;
        if (this.variantSelect && detail.variantId) this.variantSelect.value = detail.variantId;
      }

      /*
        Se muestra cuando el botón de comprar principal sale de la pantalla.
        Con IntersectionObserver y no escuchando el scroll: el observador no
        corre en cada píxel de desplazamiento, así que no cuesta fluidez en
        móvil, que es justo donde más se nota.
      */
      watchTrigger() {
        const disparador = document.querySelector('.ff-product__buttons');
        if (!disparador) {
          this.reveal(true);
          return;
        }

        // La barra sale desde el PRIMER scroll, no al cargar la página. Con
        // el pie de página quieto la primera pantalla se ve limpia —foto,
        // nombre, precio— y en cuanto alguien mueve el dedo tiene el botón a
        // mano. Al cargar no ha hecho falta todavía.
        //
        // Se guarda si ya hubo scroll y se recalcula: con dos condiciones
        // (hubo scroll · los botones no están a la vista) el estado siempre
        // sale del mismo sitio, y no de quién llegó antes.
        this.scrolled = window.scrollY > 8;
        this.buttonsVisible = true;

        const recalcular = () => {
          this.reveal(this.scrolled && !this.buttonsVisible);
        };

        this.observer = new IntersectionObserver(
          (entradas) => {
            entradas.forEach((entrada) => {
              this.buttonsVisible = entrada.isIntersecting;
            });
            recalcular();
          },
          // El margen inferior evita que parpadee justo cuando el botón asoma
          // por el borde de abajo.
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.observer.observe(disparador);

        // `passive` porque aquí no se cancela nada: el navegador puede seguir
        // desplazando sin esperar a este código.
        window.addEventListener(
          'scroll',
          () => {
            const ahora = window.scrollY > 8;
            if (ahora === this.scrolled) return;
            this.scrolled = ahora;
            recalcular();
          },
          { passive: true }
        );
      }

      // Mientras el carrito está abierto la barra estorba: queda por encima del
      // panel o compitiendo con su botón de pago.
      watchCartDrawer() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        this.drawerObserver = new MutationObserver(() => {
          this.classList.toggle('is-hidden-by-drawer', drawer.classList.contains('active'));
        });
        this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }

      reveal(mostrar) {
        if (mostrar === this.visible) return;
        this.visible = mostrar;

        if (mostrar) {
          this.hidden = false;
          // Un fotograma de margen para que la transición tenga desde dónde
          // arrancar: sin esto el navegador pinta el estado final de golpe.
          requestAnimationFrame(() => this.classList.add('is-visible'));
        } else {
          this.classList.remove('is-visible');
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.drawerObserver) this.drawerObserver.disconnect();
      }
    }
  );
}

/* ---------- Campos de personalización (una vela, un nombre) ----------

   Enseña exactamente tantos campos como velas trae la variante elegida, y
   apaga el resto. Apagar y no BORRAR es deliberado: quien pasa de 12 velas a
   6 y vuelve a 12 recupera lo que había escrito.

   `disabled` es lo que de verdad decide qué viaja al carrito — un campo
   apagado no se recoge. El `hidden` es solo cosmético, y por sí solo no
   bastaría: el navegador lo enviaría igual.

   Los <input> están fuera del <form> y enganchados con el atributo `form`,
   así que este bloque se puede mover en el editor sin romper nada. */

if (!customElements.get('ff-personalize')) {
  customElements.define(
    'ff-personalize',
    class FfPersonalize extends HTMLElement {
      connectedCallback() {
        try {
          this.cuentas = JSON.parse(this.dataset.counts || '{}');
        } catch (e) {
          this.cuentas = {};
        }

        this.campos = Array.from(this.querySelectorAll('.ff-personalize__field'));
        this.aviso = this.querySelector('[data-ff-prop-error]');
        this.obligatorio = this.dataset.requireAll === 'true';

        // Al escribir se retira el aviso: dejarlo puesto mientras el cliente
        // ya está corrigiendo es ruido.
        //
        // Y de paso se fuerza UNA SOLA PALABRA: en la cera no cabe más, y un
        // nombre partido en dos deja al taller adivinando. Se limpia aquí en
        // vez de bloquear la barra espaciadora para que pegar un texto también
        // quede bien; escribir un espacio simplemente no hace nada.
        this.addEventListener('input', (event) => {
          const campo = event.target;
          if (campo && campo.hasAttribute('data-ff-prop') && /\s/.test(campo.value)) {
            const cursor = campo.selectionStart;
            const limpio = campo.value.replace(/\s+/g, '');
            const quitados = campo.value.length - limpio.length;
            campo.value = limpio;
            // Sin esto el cursor salta al final en mitad de una palabra.
            try {
              campo.setSelectionRange(cursor - quitados, cursor - quitados);
            } catch (e) {
              /* algunos navegadores no lo permiten en ciertos tipos */
            }
          }
          this.ocultarAviso();
        });

        /* ff-product.js avisa de cada cambio de variante con este evento.
           Es la única vía: el selector de opciones no toca el <select> de
           nadie, resuelve la variante por su cuenta. */
        this.alCambiar = (event) => {
          const id = event.detail && event.detail.variantId;
          if (id) this.mostrar(this.cuentas[String(id)] || 0);
        };
        document.addEventListener('ff:product-change', this.alCambiar);
      }

      disconnectedCallback() {
        document.removeEventListener('ff:product-change', this.alCambiar);
      }

      mostrar(cuantos) {
        this.campos.forEach((campo) => {
          const sobra = Number(campo.dataset.slot) > cuantos;
          campo.hidden = sobra;
          const input = campo.querySelector('input');
          if (input) input.disabled = sobra;
        });
        this.ocultarAviso();
      }

      /* Lo que se manda al carrito. Los vacíos NO se envían: una propiedad en
         blanco se vería igualmente en el pedido y en el carrito, como una
         línea muda que no dice nada. */
      recoger() {
        const props = {};
        this.querySelectorAll('input[data-ff-prop]').forEach((input) => {
          if (input.disabled) return;
          const valor = input.value.trim();
          if (!valor) return;
          const nombre = input.name.replace(/^properties\[/, '').replace(/\]$/, '');
          props[nombre] = valor;
        });
        return props;
      }

      /* Devuelve true si se puede seguir. Con la casilla de obligatorio
         encendida, marca los que falten y lleva el foco al primero: sin eso,
         en móvil el aviso puede quedar fuera de pantalla y parecería que el
         botón no hace nada. */
      valida() {
        if (!this.obligatorio) return true;

        const vacios = Array.from(this.querySelectorAll('input[data-ff-prop]')).filter(
          (input) => !input.disabled && !input.value.trim()
        );

        this.querySelectorAll('input[data-ff-prop]').forEach((i) =>
          i.classList.remove('is-missing')
        );
        if (!vacios.length) {
          this.ocultarAviso();
          return true;
        }

        vacios.forEach((i) => i.classList.add('is-missing'));
        if (this.aviso) {
          this.aviso.textContent = this.dataset.errorText || '';
          this.aviso.hidden = false;
        }
        vacios[0].focus();
        vacios[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        return false;
      }

      ocultarAviso() {
        if (this.aviso) this.aviso.hidden = true;
        this.querySelectorAll('.is-missing').forEach((i) => i.classList.remove('is-missing'));
      }
    }
  );
}
